import { render, staticRenderFns } from "./Tab2.vue?vue&type=template&id=1dfcecff&scoped=true"
import script from "./Tab2.vue?vue&type=script&lang=js"
export * from "./Tab2.vue?vue&type=script&lang=js"
import style0 from "./Tab2.vue?vue&type=style&index=0&id=1dfcecff&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfcecff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dfcecff')) {
      api.createRecord('1dfcecff', component.options)
    } else {
      api.reload('1dfcecff', component.options)
    }
    module.hot.accept("./Tab2.vue?vue&type=template&id=1dfcecff&scoped=true", function () {
      api.rerender('1dfcecff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/evaluators/components/Tab2.vue"
export default component.exports